import { useEffect, useState } from "react";
import useTransportOrderService from "../../../app/services/hooks/useTransportOrderService";
import { TransportOrderFilters } from "../../../app/models/TransportOrder";
import { ServiceResponse } from "../../../app/services/shared/interfaces";
import { toast } from "react-toastify";
import { formatMoney } from "../../../utils/utils";
import useExpenseService from "../../../app/services/hooks/useExpenseService";
import { ExpenseDataForm, ExpenseFilters } from "../../../app/models/Expense";
import useTollExpenseService from "../../../app/services/hooks/useExpenseTollService";
import { TollExpenseFilters } from "../../../app/models/TollExpense";
import CommissionsDataTable from "./tables/CommissionsDataTable";
import ExpensesByWorkerDataTable from "./tables/ExpensesByWorkerDataTable";
import TollExpensesByWorkerDataTable from "./tables/TollExpensesByWorkerDataTable";


interface Props {
    transportOrderFilter: TransportOrderFilters;
    setTransportOrderFilter: (transportOrderFilter: TransportOrderFilters) => void;
    expensesFilter: ExpenseFilters;
    setExpensesFilter: (expensesFilter: ExpenseFilters) => void;
    tollExpensesFilter: TollExpenseFilters;
    setTollExpensesFilter: (tollExpensesFilter: TollExpenseFilters) => void;
    setCommissionTotal: (total: number) => void;
    commissionTotal: number;
    setTollExpensesTotalAmount: (total: number) => void;
    tollExpensesTotalAmount: number;
    setExpensesTotalAmount: (total: number) => void;
    expensesTotalAmount: number;
}

const CommissionsContainer = ({ 
    transportOrderFilter, 
    setTransportOrderFilter,
    expensesFilter,
    setExpensesFilter,
    tollExpensesFilter,
    setTollExpensesFilter,
    setCommissionTotal,
    commissionTotal,
    setTollExpensesTotalAmount,
    tollExpensesTotalAmount,
    setExpensesTotalAmount,
    expensesTotalAmount
}: Props) => {

       // COMISIONES
    const { getCommissionsInfoByWorker, 
        getCommissionsSumByWorker, 
        fetchingGetCommissionsInfoByWorker, 
        fetchingGetCommissionsSumByWorker } = useTransportOrderService();
    
    const [transportOrders, setTransportOrders] = useState<any[]>([]);
    const [transportOrderRows, setTransportOrderRows] = useState(0);
    const [transportOrderShowDataTable, setTransportOrderShowDataTable] = useState<boolean>(false);

    useEffect(()=>{
        if(transportOrderShowDataTable){
            getCommissionsInfoByWorker(transportOrderFilter, {
                onSuccess: (response: ServiceResponse) => {
                    setTransportOrders(response.data.transport_order)
                    setTransportOrderRows(response.data.total_rows)
                },
                onError: (response: ServiceResponse) => {
                    toast.error(response.message);
                }
            })
        }
    }, [ transportOrderFilter, 
        transportOrderShowDataTable, 
        transportOrderFilter.page, 
        transportOrderFilter.per_page
    ]);

    useEffect(()=>{
        getCommissionsSumByWorker(transportOrderFilter, {
            onSuccess: (response: ServiceResponse) => {
                setCommissionTotal(response.data.total_commissions)
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            }
        })
        
    },[transportOrderFilter]);


    const showCommissionTable = () => {
        setTransportOrderShowDataTable(!transportOrderShowDataTable)
    }

    // GASTOS
    const { getExpensesTotalAmount, 
        getNonTollExpenses,
        fetchingGetExpensesTotalAmount,
        fetchingGetNonTollExpenses } = useExpenseService();

    const [expensesShowDataTable, setExpensestShowDataTable] = useState<boolean>(false);
    const [expenses, setExpenses] = useState<ExpenseDataForm[]>([]);
    const [expensesTotalRows, setExpensesTotalRows] = useState(0);

    useEffect(()=>{

        getExpensesTotalAmount(expensesFilter, {
            onSuccess: (response: ServiceResponse) => {
                setExpensesTotalAmount(response.data.total_amount)
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            }
        })
        
    },[expensesFilter]);

    useEffect(()=>{
        if(expensesShowDataTable){
            getNonTollExpenses(expensesFilter, {
                onSuccess: (response: ServiceResponse) => {
                    setExpenses(response.data.expenses);
                    setExpensesTotalRows(response.data.total_rows);
                },
                onError: (response: ServiceResponse) => {
                    toast.error(response.message);
                }
            })
        }
    },[expensesFilter, expensesShowDataTable, expensesFilter.page, expensesFilter.per_page]);

    const showExpensesData = () => {
        setExpensestShowDataTable(!expensesShowDataTable)
    };


   //PEAJES
    const {getTollExpenseSumByWorker, 
        getAllTollExpenses,
        fetchingGetTollExpensesSum,
        fetchingGetTollExpenses} = useTollExpenseService()

    const [tollExpensesShowDataTable, setTollExpensestShowDataTable] = useState<boolean>(false);
    const [tollExpenses, setTollExpenses] = useState<ExpenseDataForm[]>([]);
    const [tollExpensesTotalRows, setTollExpensesTotalRows] = useState(0);

    const showTollExpensesData = () => {
        setTollExpensestShowDataTable(!tollExpensesShowDataTable)
    };

    useEffect(()=>{
        if(tollExpensesShowDataTable){
            getAllTollExpenses(tollExpensesFilter, {
                onSuccess: (response: ServiceResponse) => {
                    setTollExpenses(response.data.toll_expenses);
                    setTollExpensesTotalRows(response.data.total_rows);
                },
                onError: (response: ServiceResponse) => {
                    toast.error(response.message);
                }
            })
        }
    },[tollExpensesFilter, tollExpensesShowDataTable, tollExpensesFilter.page, tollExpensesFilter.per_page]);

    useEffect(()=>{
        getTollExpenseSumByWorker(tollExpensesFilter, {
            onSuccess: (response: ServiceResponse) => {
                setTollExpensesTotalAmount(response.data.total_amount)
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            }
        })
    },[tollExpensesFilter]);

    

    return (
        <>
           <div className="row justify-content-start">

                <div className="col-lg-3">
                    <div
                        className="mini-stats-wid card p-2 icon-pointer"
                        style={{
                            backgroundColor: '#BCCAB9',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                        }}
                        onClick={showCommissionTable}
                    >
                        <div className="d-flex">
                            <div className="flex-grow-1">
                                <p className="fw-medium " style={{ userSelect: 'none' }}>Comisiones</p>
                                {fetchingGetCommissionsSumByWorker ? (
                                    <h5 className="mb-0">...</h5>
                                ) : (
                                    <h5 className="mb-0" style={{ userSelect: 'none' }}>{formatMoney(commissionTotal)}</h5>
                                )}
                            </div>
                        </div>
                    </div>
                </div>  


                {transportOrderShowDataTable &&                
                    <div className="col-lg-10 mb-4">
                        <div className="h5">Detalle Ordenes de Transporte</div>
                        <CommissionsDataTable 
                            data={transportOrders}
                            progressPending={fetchingGetCommissionsInfoByWorker}
                            totalRows={transportOrderRows}
                            filter={transportOrderFilter}
                            setFilter={setTransportOrderFilter}
                        />
                    </div>
                }  


                <div className="col-lg-3">
                    <div
                        className="mini-stats-wid card p-2 icon-pointer"
                        style={{
                            backgroundColor: '#BCCAB9',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                        }}
                        onClick={showExpensesData}
                    >
                        <div className="d-flex">
                            <div className="flex-grow-1">
                                <p className="fw-medium " style={{ userSelect: 'none' }}>Gastos</p>
                                {fetchingGetExpensesTotalAmount ? (
                                    <h5 className="mb-0">...</h5>
                                ) : (
                                    <h5 className="mb-0" style={{ userSelect: 'none' }}>{formatMoney(expensesTotalAmount)}</h5>
                                )}
                            </div>
                        </div>
                    </div>
                </div>  

                {expensesShowDataTable && expenses.length > 0 ? 
                    (               
                        <div className="col-lg-10 mb-4">
                            <div className="h5">Detalle Gastos</div>
                            <ExpensesByWorkerDataTable 
                                data={expenses}
                                progressPending={fetchingGetNonTollExpenses}
                                totalRows={expensesTotalRows}
                                filter={expensesFilter}
                                setFilter={setExpensesFilter}
                            />
                        </div>
                    ) : (null)  
                }  


                {/* PEAJES*/}
                <div className="col-lg-3">
                    <div
                        className="mini-stats-wid card p-2 icon-pointer"
                        style={{
                            backgroundColor: '#BCCAB9',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                        }}
                        onClick={showTollExpensesData}
                    >
                        <div className="d-flex">
                            <div className="flex-grow-1">
                                <p className="fw-medium " style={{ userSelect: 'none' }}>Peajes</p>
                                {fetchingGetTollExpensesSum ? (
                                    <h5 className="mb-0">...</h5>
                                ) : (
                                    <h5 className="mb-0" style={{ userSelect: 'none' }}>{formatMoney(tollExpensesTotalAmount)}</h5>
                                )}
                            </div>
                        </div>
                    </div>
                </div> 

                {tollExpensesShowDataTable && tollExpenses.length > 0 ? 
                    (              
                        <div className="col-lg-10 mb-4">
                            <div className="h5">Detalle Peajes</div>
                            <TollExpensesByWorkerDataTable 
                                data={tollExpenses}
                                progressPending={fetchingGetTollExpenses}
                                totalRows={tollExpensesTotalRows}
                                filter={tollExpensesFilter}
                                setFilter={setTollExpensesFilter}
                            />
                        </div>
                    ) : (null) 
                }  

           </div>
        </>
    )

}

export default CommissionsContainer;